<template>
  <div class="exam-info">
    <NoticeBar :visible="noticeVisible" :message="noticeMessage" :type="noticeType" :actions="noticeActions"
      @close="noticeVisible = false" />
    <h3>我的报名</h3>
    <p class="file-date" v-if="date">{{ date }}</p>

    <!-- 考试报名信息（仅保留我的报名申请） -->

    <div class="info-container" v-if="!showPayment">
      
      <div v-if="loading" class="empty-hint">正在加载报名数据...</div>
      <div v-else-if="error" class="empty-hint error">{{ error }}</div>
      <table v-else class="simple-table">
        <thead>
          <tr>
            <th>考试名称</th>
            <th>审核状态</th>
            <th>缴费状态</th>
            <th>拒绝原因</th>
            <th>操作</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="app in paginatedApplications" :key="app.id">
            <td v-if="app.audit_status !== 'approved'" class="clickable" title="查看/修改报名资料" @click="openEdit(app)">{{ app.exam_title || app.exam_name }}</td>
            <td v-else>{{ app.exam_title || app.exam_name }}</td>
            <td>
              <span :class="['status-tag', app.audit_status === 'approved' ? 'status-approved' : 'status-pending']">
                {{ mapAuditStatus(app) }}
              </span>
            </td>
      <td>
              {{
                (app.audit_status === 'approved' && app.payment_status === 'unpaid')
                  ? (app._receipt_rejected ? '被驳回' : (app._pay_pending ? '待审核' : mapPayStatus(app.payment_status)))
                  : mapPayStatus(app.payment_status)
              }}
      </td>
            <td>{{ displayRejectReason(app) }}</td>
            <td>
              <button
                v-if="app.audit_status === 'approved' && app.payment_status === 'unpaid' && !app._pay_pending"
                class="btn-action btn-primary"
                @click="goPay(app)"
              >{{ app._receipt_rejected ? '重新上传付款截图' : '去支付' }}</button>
              <button
                v-if="app.audit_status === 'approved' && app.payment_status === 'unpaid' && !app._pay_pending"
                class="btn-action btn-secondary"
                @click="confirmPaid(app)"
              >确认已支付</button>
              <!-- 打印准考证按钮：仅当审核通过、已缴费且准考证已发布时显示 -->
              <button
                v-if="app.audit_status === 'approved' && app.payment_status === 'paid' && app.ticket_available"
                class="btn-action btn-primary"
                @click="goPrintTicket(app)"
              >打印准考证</button>
              <!-- 准考证未发布状态 -->
              <span
                v-else-if="app.audit_status === 'approved' && app.payment_status === 'paid'"
                class="status-tag status-pending"
              >准考证未发布</span>
              <button
                v-if="app.audit_status === 'rejected' && app.exam && app.exam.allow_modification"
                class="btn-action btn-primary"
                @click="reupload(app)"
              >重新上传资料</button>
            </td>
          </tr>
          <tr v-if="applications.length === 0">
            <td colspan="5" style="text-align:center;color:#888;">暂无报名记录</td>
          </tr>
        </tbody>
      </table>
      <!-- 分页 -->
      <div class="pagination">
        <span class="pagination-total">共 {{ applications.length }} 条</span>
        <select v-model="appPageSize" @change="appPage = 1" class="page-size-select">
          <option :value="10">10条/页</option>
          <option :value="20">20条/页</option>
          <option :value="50">50条/页</option>
        </select>
        <button class="btn-page" :disabled="appPage <= 1" @click="appPage--">‹</button>
        <span class="page-current">{{ appPage }}</span>
        <button class="btn-page" :disabled="appPage >= appTotalPages" @click="appPage++">›</button>
      </div>
    </div>

      <div class="payment-section" v-else>
        <div class="payment-header">
          <h4>缴费信息</h4>
          <button class="btn-action btn-secondary" @click="closePaymentView">返回报名列表</button>
        </div>
        <p class="exam-title"><strong>考试名称：</strong>{{ payingApp?.exam_title || payingApp?.exam_name || '-' }}</p>
        <div class="payment-info">
          <p><strong>报名费用：</strong>{{ paymentInfo.fee }}</p>
          <p><strong>状态：</strong><span :class="['status-tag', paymentInfo.statusClass]">{{ paymentInfo.status }}</span>
          </p>
          <p class="payment-hint">{{ paymentInfo.hint }}</p>
        </div>
        <div class="payment-qr-codes">
          <div class="qr-code-item">
            <div class="qr-code-title">
              <span>微信支付</span>
            </div>
            <div class="qr-code">
              <div v-if="payCodeUrl">
                <img :src="qrImgSrc" alt="微信支付二维码" />
              </div>
              <!-- 加载中时不显示文字提示，保持空白占位 -->
            </div>
          </div>
          <!--
          <div class="qr-code-item">
            <div class="qr-code-title">
              <span>支付宝支付</span>
            </div>
            <div class="qr-code">
              <p class="qr-hint">请使用支付宝扫码支付</p>
            </div>
          </div>
          -->
        </div>
        <div class="upload-receipt">
          <h5>上传付款截图</h5>
          <div class="upload-bar">
            <input type="file" accept="image/*" @change="onFileChange" />
            <button class="btn-action btn-primary" :disabled="!selectedFile" @click="uploadReceipt">上传</button>
            <button class="btn-action btn-secondary" v-if="receipts.length" @click="openGallery">查看已上传的付款截图</button>
          </div>
          <!-- 取消页面内展示缩略图，改为弹窗展示，与后台管理端预览交互保持一致 -->
        </div>
        <div class="payment-tips">
          <h5>支付注意事项：</h5>
          <ul>
            <li>支付完成后请等待系统确认，不要立即关闭页面</li>
            <li>如遇支付问题，请联系技术支持：400-123-4567</li>
            <li>支付成功后可在“我的报名申请”查看报名状态</li>
          </ul>
        </div>
      </div>
      <!-- 详情弹窗 -->
      <div class="modal-mask" v-if="detailVisible">
        <div class="modal-wrapper" @click.self="closeDetail">
          <div class="modal-container">
            <div class="modal-header">
              <span>{{ detailExam?.title || '考试详情' }}</span>
              <button class="modal-close" @click="closeDetail">×</button>
            </div>
            <div class="modal-body">
              <p><strong>类别：</strong>{{ detailExam?.category || '-' }}</p>
              <p><strong>报名时间：</strong>{{ detailExam?.enroll_start_time || '-' }} ~ {{ detailExam?.enroll_end_time || '-' }}</p>
              <p><strong>考试时间：</strong>{{ detailExam?.start_time || '-' }} ~ {{ detailExam?.end_time || '-' }}</p>
              <p><strong>费用：</strong>{{ detailExam?.fee != null ? ('¥' + Number(detailExam.fee).toFixed(2)) : '¥--' }}</p>
              <p><strong>状态：</strong>{{ detailExam?.status === 1 ? '已发布' : (detailExam?.status === 2 ? '已结束' : '草稿') }}</p>
            </div>
            <div class="modal-footer">
              <button class="btn-action btn-primary" @click="closeDetail">关闭</button>
            </div>
          </div>
        </div>
      </div>

      <!-- 统一图片画廊/预览弹窗（原生 dialog 单一弹窗） -->
      <dialog class="modal" ref="lightboxDialog">
        <div class="modal-container wide">
          <div class="modal-header">
            <span>已上传的付款截图</span>
            <button class="modal-close" @click="closeLightbox">×</button>
          </div>
          <div class="modal-body">
            <div class="lightbox-main">
              <img :src="currentImage" alt="图片预览" />
            </div>
            <div class="lightbox-controls">
              <button class="btn-action btn-secondary" @click="prevImage" :disabled="!receipts.length">上一张</button>
              <button class="btn-action btn-secondary" @click="nextImage" :disabled="!receipts.length">下一张</button>
            </div>
            <div class="lightbox-thumbs">
              <div class="thumb" v-for="(r,i) in receipts" :key="r.id" :class="{ active: i === currentIndex }" @click="setCurrent(i)">
                <img :src="resolveUrl(r.image_url)" alt="缩略图" />
                <div class="receipt-time">{{ r.upload_time }}</div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button class="btn-action btn-primary" @click="closeLightbox">关闭</button>
          </div>
        </div>
      </dialog>
      <!-- 查看/修改报名资料弹窗 -->
      <div class="modal-mask" v-if="editDialogVisible">
        <div class="modal-wrapper" @click.self="closeEdit">
          <div class="modal-container wide">
            <div class="modal-header">
              <span>查看/修改报名资料</span>
              <button class="modal-close" @click="closeEdit">×</button>
            </div>
            <div class="modal-body">
              <exam-registration-form
                v-if="editExam && editSubmission"
                :exam="editExam"
                :submission="editSubmission"
                :editable="editEditable"
                :layout="'sheet'"
                @submitted="onEditedSubmitted"
              />
              <div v-else class="empty-hint">正在加载报名数据...</div>
              <p v-if="!editEditable" class="hint" style="margin-top:8px;">该报名已审核通过，当前仅支持查看，不可修改</p>
            </div>
            <div class="modal-footer">
              <button class="btn-action btn-secondary" @click="closeEdit">关闭</button>
            </div>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
import { listMyApplications, getExam, createWechatNativeOrder } from '../api/exams'
import { getUser } from '../api/storage'
import ExamRegistrationForm from './ExamRegistrationForm.vue'
import NoticeBar from './NoticeBar.vue'

export default {
  name: 'ExamInfo',
  components: { ExamRegistrationForm, NoticeBar },
  props: {
    date: {
      type: String,
      default: ''
    },
    personalInfo: {
      type: Array,
      default: () => []
    },
    examInfo: {
      type: Array,
      default: () => []
    },
  },
  emits: ['open-ticket-list'],
  data() {
    return {
      applications: [],
      loading: false,
      error: '',
      appPage: 1,
      appPageSize: 10,
      payingAppId: null,
      payCodeUrl: '',
      receipts: [],
      selectedFile: null,
      payPollTimer: null,
      detailVisible: false,
      detailExam: null,
      currentIndex: 0,
      editDialogVisible: false,
      editExam: null,
      editSubmission: null,
      editEditable: true
    }
  },
  computed: {
    currentUsername() {
      const u = getUser()
      return u?.username || ''
    },
    currentImage() {
      const r = this.receipts[this.currentIndex]
      return r ? this.resolveUrl(r.image_url) : ''
    },
    payingApp() {
      if (!this.payingAppId) return null
      return this.applications.find(a => a.id === this.payingAppId) || null
    },
    showPayment() {
      // 仅在点击“去支付”后展示缴费区域
      if (!this.payingAppId) return false
      const app = this.applications.find(a => a.id === this.payingAppId)
      return !!(app && app.audit_status === 'approved' && app.payment_status === 'unpaid')
    },
    paymentInfo() {
      const app = (this.payingAppId
        ? this.applications.find(a => a.id === this.payingAppId)
        : this.applications.find(a => a.audit_status === 'approved' && a.payment_status === 'unpaid'))
      if (!app) return {
        fee: '¥0.00', status: '无待缴费', statusClass: 'status-pending', hint: '暂无待缴费申请'
      }
      const fee = (app.fee != null) ? `¥${Number(app.fee).toFixed(2)}` : '¥--'
      return {
        fee,
        status: '待支付',
        statusClass: 'status-pending',
        hint: '请在规定时间内完成支付，逾期将视为自动放弃报名'
      }
    },
    qrImgSrc() {
      if (!this.payCodeUrl) return ''
      // 若为 weixin:// 形式，则生成二维码；否则直接当作图片链接（快速方案：后台配置收款码）
      return this.payCodeUrl.startsWith('weixin://')
        ? `https://api.qrserver.com/v1/create-qr-code/?size=180x180&data=${encodeURIComponent(this.payCodeUrl)}`
        : this.payCodeUrl
    },
    statusSummary() {
      const apps = this.applications || []
      const pending = apps.filter(a => a.audit_status !== 'approved' && a.audit_status !== 'rejected').length
      const approvedUnpaid = apps.filter(a => a.audit_status === 'approved' && a.payment_status === 'unpaid').length
      const approvedPaid = apps.filter(a => a.audit_status === 'approved' && a.payment_status === 'paid').length
      const rejected = apps.filter(a => a.audit_status === 'rejected').length
      return { pending, approvedUnpaid, approvedPaid, rejected }
    },
    appTotalPages() {
      return Math.ceil(this.applications.length / this.appPageSize) || 1
    },
    paginatedApplications() {
      const start = (this.appPage - 1) * this.appPageSize
      return this.applications.slice(start, start + this.appPageSize)
    }
  },
  mounted() {
    this.fetchData()
    window.addEventListener('keydown', this._onKeyDown)
  },
  methods: {
    showNotice(message, type = 'info', actions = [], autoHideMs = 2500) {
      this.noticeMessage = message
      this.noticeType = type
      this.noticeActions = actions
      this.noticeVisible = true
      if (autoHideMs > 0) {
        setTimeout(() => { this.noticeVisible = false }, autoHideMs)
      }
    },
    displayRejectReason(app) {
      // 报名被驳回时优先显示报名的驳回原因
      if (app && app.audit_status === 'rejected') {
        return app.reject_reason || '报名资料被驳回'
      }
      // 支付截图被驳回时显示截图驳回原因
      if (app && app._receipt_rejected) {
        return app._receipt_reject_reason || '支付截图被驳回'
      }
      return '-'
    },
    async fetchData() {
      this.error = ''
      this.loading = true
      try {
        const raw = await listMyApplications()
        // 使用后端聚合字段：latest_receipt_review_status / latest_receipt_review_reason
        const list = Array.isArray(raw) ? raw : []
        // 读取已发布的准考证列表，用于兜底标记 ticket_available
        let publishedSet = new Set()
        try {
          const tickets = await (await import('../api/exams')).listMyTickets()
          const ids = Array.isArray(tickets)
            ? tickets
              .filter(t => t?.is_published === true || t?.published === true)
              .map(t => String(t.exam_id || t.exam?.id || ''))
            : []
          publishedSet = new Set(ids.filter(Boolean))
        } catch (_) {}
        this.applications = list.map(a => {
          const s = String(a?.latest_receipt_review_status || '').toLowerCase()
          const rejected = (s === 'rejected')
          const pending = (s === 'pending')
          return {
            ...a,
            _receipt_rejected: rejected,
            _receipt_reject_reason: a?.latest_receipt_review_reason || '',
            _pay_pending: (a?.audit_status === 'approved' && a?.payment_status === 'unpaid' && pending),
            ticket_available: Boolean(a?.ticket_available || publishedSet.has(String(a?.exam_id || a?.exam?.id || '')))
          }
        })
      } catch (e) {
        console.error(e)
        const status = e?.response?.status
        if (status === 401) {
          this.error = '未登录或登录已过期，请先登录后查看报名申请'
        } else if (status === 403) {
          this.error = '当前账户无权限查看报名申请'
        } else {
          this.error = '数据加载失败，请稍后重试'
        }
      } finally {
        this.loading = false
      }
    },
    mapAuditStatus(app) {
      const s = app.audit_status
      if (s === 'approved') return '审核通过'
      if (s === 'rejected') {
         if (app.exam && !app.exam.allow_modification) return '审核未通过(禁止修改)'
         return '审核未通过'
      }
      return '待审核'
    },
    mapPayStatus(s) {
      if (s === 'paid') return '已缴费'
      if (s === 'unpaid') return '未缴费'
      return '未知'
    },
    async goPay(app) {
      const id = app?.id
      if (!id) return
      this.payingAppId = id
      this.payCodeUrl = ''
      try {
        // 快速方案：读取后台配置的个人收款二维码
        const resp = await fetch('/api/exam/payment-config/current/')
        if (!resp.ok) throw new Error(`HTTP ${resp.status}`)
        let data
        try {
          data = await resp.json()
        } catch (e) {
          throw new Error('解析响应数据失败')
        }
        this.payCodeUrl = data?.wechat_qr_url || ''
        // 兼容：如后台未配置，则回退到模拟的微信支付 code_url
        if (!this.payCodeUrl) {
          const res = await createWechatNativeOrder(id)
          this.payCodeUrl = res?.code_url || ''
        }
        // 拉取已有付款截图
        await this.loadReceipts(id)
      } catch (e) {
        console.error(e)
        this.showNotice('加载支付信息失败，请稍后重试', 'error')
        return
      }
      this.$nextTick(() => {
        const el = document.querySelector('.payment-section')
        if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' })
      })
      this.startPoll()
    },
    async loadReceipts(appId) {
      try {
        const res = await fetch(`/api/exam/applications/${appId}/receipts/`, { headers: this._authHeaders() })
        if (res.ok) {
          try {
            const receipts = await res.json()
            this.receipts = Array.isArray(receipts) ? receipts : []
          } catch (e) {
            console.error('解析付款截图列表失败', e)
            this.receipts = []
          }
        }
      } catch (_) {}
    },
    startPoll() {
      if (this.payPollTimer) clearInterval(this.payPollTimer)
      this.payPollTimer = setInterval(async () => {
        try {
          const list = await listMyApplications()
          const prev = this.applications
          // 保留本地待审核标记（仅在未缴费时）
          this.applications = list.map(a => {
            const old = prev.find(x => x.id === a.id)
            if (old && old._pay_pending && a.payment_status === 'unpaid') {
              return { ...a, _pay_pending: true }
            }
            return a
          })
          const app = list.find(a => a.id === this.payingAppId)
          if (app && app.payment_status === 'paid') {
            clearInterval(this.payPollTimer)
            this.payPollTimer = null
            this.showNotice('支付成功，已自动更新缴费状态', 'success')
          }
        } catch (e) {}
      }, 3000)
    },
    async confirmPaid(app) {
      const id = app?.id
      if (!id) return
      try {
        // 先检查是否已上传付款截图
        const res = await fetch(`/api/exam/applications/${id}/receipts/`, { headers: this._authHeaders() })
        if (!res.ok) throw new Error(`HTTP ${res.status}`)
        let receipts
        try {
          receipts = await res.json()
        } catch (e) {
          throw new Error('解析响应数据失败')
        }
        if (!Array.isArray(receipts) || receipts.length === 0) {
          // 若当前正处于支付页面且已选择文件但未上传，则提示先点击上传
          if (this.payingAppId === id && this.selectedFile) {
            this.showNotice('已选择图片，请先点击"上传"后再确认已支付', 'warning')
          } else {
            this.showNotice('请先选择并上传付款截图后再确认已支付', 'warning')
          }
          return
        }
        // 若最新付款截图为已驳回，提示用户重新选择文件并上传
        const latest = receipts[0]
        if (latest && String(latest.review_status).toLowerCase() === 'rejected') {
          this.showNotice('付款截图已被驳回，请重新选择图片并上传后再确认已支付', 'warning')
          return
        }
        // 有付款截图：置本地待审核标记，提示进入待确认，并开始轮询
        this.applications = this.applications.map(x => x.id === id ? { ...x, _pay_pending: true } : x)
        this.showNotice('已提交待确认，等待管理员审核付款截图', 'info')
        this.startPoll()
      } catch (e) {
        console.error(e)
        this.showNotice(`确认支付失败：${e?.message || '请稍后重试'}`, 'error')
      }
    },
    onFileChange(e) {
      const f = e.target.files?.[0]
      this.selectedFile = f || null
    },
    async uploadReceipt() {
      if (!this.payingAppId) return
      if (!this.selectedFile) {
        this.showNotice('请先选择要上传的付款截图', 'warning')
        return
      }
      try {
        const fd = new FormData()
        fd.append('image', this.selectedFile)
        const res = await fetch(`/api/exam/applications/${this.payingAppId}/receipts/upload/`, {
          method: 'POST',
          headers: this._authHeaders(),
          body: fd
        })
        if (!res.ok) {
          const txt = await res.text().catch(() => '')
          throw new Error(txt || `HTTP ${res.status}`)
        }
        let data
        try {
          data = await res.json()
        } catch (e) {
          throw new Error('解析响应数据失败')
        }
        if (data) {
          this.receipts = Array.isArray(this.receipts) ? [data, ...this.receipts] : [data]
        }
        this.selectedFile = null
        this.showNotice('付款截图上传成功', 'success')
      } catch (e) {
        console.error(e)
        this.showNotice(`上传失败：${e?.message || '请稍后重试'}`, 'error')
      }
    },
    reupload(app) {
      // 恢复为跳转到报名页面的逻辑（昨日行为）
      const examId = app?.exam_id
      if (!examId && examId !== 0) {
          this.showNotice('未能获取考试ID，无法重新上传', 'error')
        return
      }
      window.location.hash = `exam-register/${examId}`
    },
    async openEdit(app) {
      try {
        const examId = app?.exam_id
        if (examId === undefined || examId === null) {
          this.showNotice('未能获取考试ID，无法查看/修改', 'error')
          return
        }
        // 无论报名状态如何，都允许进入报名页查看信息
        // 移除直接跳转到准考证页面的逻辑，让用户自己选择操作
        window.location.hash = `exam-register/${examId}`
      } catch (e) {
        console.error(e)
        this.showNotice('加载报名信息失败，请稍后重试', 'error')
      }
    },
    goPrintTicket(app) {
      // 跳转到准考证打印列表页面
      this.$emit('open-ticket-list')
    },
    closeEdit() {
      this.editDialogVisible = false
      this.editExam = null
      this.editSubmission = null
      this.editEditable = true
    },
    async onEditedSubmitted() {
      await this.fetchData()
      this.closeEdit()
      this.showNotice('已更新报名资料，进入待审核状态', 'success')
    },
    async viewDetail(app) {
      const examId = app?.exam_id
      if (!examId && examId !== 0) {
        this.showNotice('未能获取考试ID，无法查看详情', 'error')
        return
      }
      try {
        this.detailExam = await getExam(examId)
        this.detailVisible = true
      } catch (e) {
        console.error(e)
        this.showNotice('获取考试详情失败，请稍后重试', 'error')
      }
    },
    closeDetail() { this.detailVisible = false; this.detailExam = null },
    openImagePreview(src) {
      // 统一弹窗：定位到指定图片并打开
      const idx = this.receipts.findIndex(r => this.resolveUrl(r.image_url) === src)
      this.currentIndex = idx >= 0 ? idx : 0
      this.$nextTick(() => { this.$refs.lightboxDialog?.showModal() })
    },
    openGallery() {
      // 打开画廊，默认显示最新一张
      this.currentIndex = this.receipts.length ? (this.receipts.length - 1) : 0
      this.$nextTick(() => { this.$refs.lightboxDialog?.showModal() })
    },
    resolveUrl(path) {
      if (!path) return ''
      const s = String(path)
      if (s.startsWith('http://') || s.startsWith('https://')) return s
      const normalized = s.startsWith('/') ? s : `/${s}`
      if (normalized.startsWith('/media') || normalized.startsWith('/api')) return normalized
      const backendBase = `${window.location.protocol}//${window.location.hostname}:8000`
      return `${backendBase}${normalized}`
    },
    closeLightbox() {
      try { this.$refs.lightboxDialog?.close() } catch (e) {}
    },
    setCurrent(i) {
      if (i >= 0 && i < this.receipts.length) this.currentIndex = i
    },
    prevImage() {
      if (!this.receipts.length) return
      this.currentIndex = (this.currentIndex - 1 + this.receipts.length) % this.receipts.length
    },
    nextImage() {
      if (!this.receipts.length) return
      this.currentIndex = (this.currentIndex + 1) % this.receipts.length
    },
    closePaymentView() {
      if (this.payPollTimer) {
        clearInterval(this.payPollTimer)
        this.payPollTimer = null
      }
      this.payingAppId = null
      this.payCodeUrl = ''
      this.receipts = []
    },
    _onKeyDown(e) {
      const key = e?.key || e?.code || ''
      if (key === 'Escape' || key === 'Esc') {
        if (this.detailVisible) this.closeDetail()
        if (this.$refs.lightboxDialog?.open) this.closeLightbox()
      } else if (key === 'ArrowLeft') {
        if (this.$refs.lightboxDialog?.open) this.prevImage()
      } else if (key === 'ArrowRight') {
        if (this.$refs.lightboxDialog?.open) this.nextImage()
      }
    },
    _authHeaders() {
      const token = localStorage.getItem('user_access_token') || ''
      return token ? { 'Authorization': `Bearer ${token}` } : {}
    }

  },
  beforeDestroy() {
    if (this.payPollTimer) {
      clearInterval(this.payPollTimer)
      this.payPollTimer = null
    }
    window.removeEventListener('keydown', this._onKeyDown)
  }
}
</script>

<style scoped>
.exam-info h3 {
  color: #0066cc;
  font-size: 20px;
  margin-bottom: 10px;
  padding-bottom: 10px;
  border-bottom: 2px solid #0066cc;
}


.file-date {
  color: #666;
  font-size: 14px;
  margin-bottom: 20px;
}

.info-container {
  margin-bottom: 30px;
  display: flex;
  gap: 30px;
  flex-wrap: wrap;
}

.info-container h4 {
  color: #333;
  font-size: 16px;
  margin-bottom: 15px;
  width: 100%;
}

.photo-container {
  flex-shrink: 0;
}

.payment-section {
  margin-top: 30px;
  padding: 20px;
  background-color: #f9f9f9;
  border-radius: 4px;
}

.clickable { cursor: pointer; color: var(--color-primary); }
.clickable:hover { text-decoration: underline; }

.payment-header { display: flex; align-items: center; justify-content: space-between; }
.payment-section h4 { color: #333; font-size: 16px; margin: 0; }
.exam-title { margin: 12px 0 8px; color: #333; }

.payment-info {
  margin-bottom: 20px;
}

.payment-info p {
  margin-bottom: 10px;
}

.payment-hint {
  color: #666;
  font-size: 14px;
}

.payment-qr-codes {
  display: flex;
  gap: 40px;
  margin-bottom: 20px;
}

.qr-code-item {
  text-align: center;
}

.qr-code-title {
  margin-bottom: 10px;
  font-weight: 500;
}

.qr-code {
  width: 180px;
  height: 180px;
  background-color: #fff;
  border: 1px solid #e5e5e5;
  border-radius: 10px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06);
  display: flex;
  align-items: center;
  justify-content: center;
}

.qr-code img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  border-radius: 8px;
}

.qr-hint {
  color: #999;
  font-size: 14px;
}

.payment-tips {
  margin-top: 20px;
}

.payment-tips h5 {
  margin-bottom: 10px;
  font-size: 14px;
}

.payment-tips ul {
  margin-left: 20px;
}

.payment-tips li {
  margin-bottom: 5px;
  font-size: 14px;
  color: #666;
}

/* 付款截图展示美化 */
.receipts { margin-top: 12px; }
.receipt-list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
  gap: 16px;
}
.receipt-item {
  background: #fff;
  border: 1px solid #eaeaea;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.06);
  transition: transform 0.15s ease, box-shadow 0.15s ease;
}
.receipt-item:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 22px rgba(0, 0, 0, 0.08);
}
.receipt-item img {
  width: 100%;
  height: 160px;
  object-fit: cover;
  display: block;
  cursor: zoom-in;
}
.receipt-time {
  padding: 8px;
  font-size: 12px;
  color: #666;
  text-align: center;
  background: #fafafa;
  border-top: 1px solid #f0f0f0;
}

.status-tag {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 10px;
  font-size: 12px;
  font-weight: 500;
}

.status-pending {
  background-color: #fff7e6;
  color: #fa8c16;
}

.status-approved {
  background-color: #f6ffed;
  color: #52c41a;
}

.simple-table {
  width: 100%;
  border-collapse: collapse;
  background-color: white;
}

.simple-table th,
.simple-table td {
  padding: 8px 10px;
  border-bottom: 1px solid #e0e0e0;
  text-align: left;
}

.simple-table th {
  background-color: #f5f9ff;
  color: #0066cc;
}

.btn-action { margin-right: 8px; padding: 6px 10px; border-radius: 4px; cursor: pointer; font-size: 12px; }
.btn-primary { background-color: #0066cc; color: #fff; border: none; }
.btn-secondary { background-color: #f0f0f0; color: #333; border: 1px solid #ddd; }

/* 轻量弹窗样式 */
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0; left: 0; right: 0; bottom: 0;
  background-color: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
}
.modal-wrapper { width: 100%; height: 100%; display: flex; align-items: center; justify-content: center; }
.modal-container {
  width: 520px;
  background: #fff;
  border-radius: 6px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.2);
}
.modal-container.wide { width: 720px; }
.modal-header { display: flex; justify-content: space-between; align-items: center; padding: 12px 16px; border-bottom: 1px solid #eee; font-weight: 600; }
.modal-close { background: none; border: none; font-size: 18px; cursor: pointer; }
.modal-body { padding: 12px 16px; }
.modal-body p { margin: 8px 0; }
.modal-footer { padding: 12px 16px; border-top: 1px solid #eee; text-align: right; }

/* 原生 dialog 弹窗样式 */
dialog.modal { border: none; padding: 0; border-radius: 6px; }
dialog.modal::backdrop { background-color: rgba(0,0,0,0.4); }

/* 图片预览样式 */
.image-preview {
  position: relative;
  max-width: 80vw;
  max-height: 80vh;
  background: #000;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.image-preview img {
  max-width: 100%;
  max-height: 100%;
}
.image-preview .modal-close {
  position: absolute;
  top: 8px;
  right: 8px;
  color: #fff;
}

/* 统一 lightbox 弹窗区域 */
.lightbox-main { display: flex; align-items: center; justify-content: center; background: #000; border-radius: 8px; height: 360px; }
.lightbox-main img { max-width: 100%; max-height: 100%; object-fit: contain; }
.lightbox-controls { display: flex; gap: 8px; margin: 10px 0; }
.lightbox-thumbs { display: grid; grid-template-columns: repeat(4, 1fr); gap: 10px; }
.lightbox-thumbs .thumb { border: 1px solid #eee; border-radius: 6px; overflow: hidden; background: #fff; cursor: pointer; }
.lightbox-thumbs .thumb.active { border-color: #0066cc; box-shadow: 0 0 0 2px rgba(0,102,204,0.2); }
.lightbox-thumbs .thumb img { width: 100%; height: 100px; object-fit: cover; display: block; }
.lightbox-thumbs .thumb .receipt-time { font-size: 12px; color: #666; padding: 6px; }

/* 分页样式 */
.pagination {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px solid #e0e0e0;
}

.pagination .pagination-total {
  color: #666;
  font-size: 14px;
}

.pagination .page-size-select {
  padding: 6px 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
}

.pagination .btn-page {
  padding: 6px 12px;
  background: #f0f0f0;
  border: 1px solid #ddd;
  border-radius: 4px;
  cursor: pointer;
  font-size: 13px;
}

.pagination .btn-page:hover:not(:disabled) {
  background: #e9ecef;
}

.pagination .btn-page:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.pagination .page-current {
  min-width: 28px;
  height: 28px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #1677ff;
  color: #fff;
  border-radius: 4px;
  font-size: 13px;
}

.pagination .page-info {
  font-size: 13px;
  color: #666;
}
</style>
